import { render } from "./AddKubernetesSupportedVersion.vue?vue&type=template&id=527d7e50&scoped=true"
import script from "./AddKubernetesSupportedVersion.vue?vue&type=script&lang=js"
export * from "./AddKubernetesSupportedVersion.vue?vue&type=script&lang=js"

import "./AddKubernetesSupportedVersion.vue?vue&type=style&index=0&id=527d7e50&scoped=true&lang=less"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527d7e50"]])

export default __exports__